export default __webpack_public_path__ + "static/media/dj.7cd05bae.svg";